import { DateRangeEnd, DateSelectorType } from '../enums';
import { TodaySelector } from './TodaySelector';
import { UpdateTuesdaySelector } from './UpdateTuesdaySelector';
import { MonthSelector } from './MonthSelector';
import { FullDateSelector } from './FullDateSelector';
import { IDateState } from '../types';

export const DateRangeSelectorChoice = ({
  type,
  dateRangeEnd,
  date,
  setDate,
}: IDateState & {
  type: DateSelectorType | undefined;
  dateRangeEnd: DateRangeEnd | undefined;
}) => {
  const sharedProps = { dateRangeEnd, date, setDate };
  switch (type) {
    case 'date':
      return <FullDateSelector {...sharedProps} />;
    case 'month':
      return <MonthSelector {...sharedProps} />;
    case 'today':
      return <TodaySelector setDate={setDate} />;
    default:
    case 'updatetuesday':
      return <UpdateTuesdaySelector {...sharedProps} />;
  }
};
